<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        {{ aLang.c_list }} tin tức
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <div class="text-left">
          <b-collapse v-bind:visible="mData.tableRules.showFormSearch" id="myFormSearch">
            <b-card>
              <el-form ref="myForm" label-position="top" @submit.native.prevent
                :model="mData.tableRules.dataSearch.value" :rules="mData.tableRules.dataSearch.valid">
                <b-row>
                  <b-col md="3">
                    <el-form-item label="Tiêu đề" prop="">
                      <el-input v-model="mData.tableRules.dataSearch.value.tieu_de" clearable
                        placeholder="Nhập từ khóa (nhấn enter để tìm kiếm)">
                      </el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item label="Người tạo" prop="">
                      <el-select v-model="mData.tableRules.dataSearch.value.nguoi_tao" placeholder="Tên người tạo"
                        :default-first-option="true" clearable filterable>
                        <el-option v-for="item in mData.dataDefault.listNguoiTaoSearch" :key="item.id"
                          :label="item.ho_ten.ho_ten" :value="item.id"></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item label="Thời điểm tạo" prop="">
                      <el-date-picker type="date" :format="aElement.datepicker.formatDate"
                        :valueFormat="aElement.datepicker.valueFormat"
                        v-model="mData.tableRules.dataSearch.value.thoi_diem_tao"
                        :placeholder="aElement.datepicker.placeholderDate" clearable filterable></el-date-picker>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item label="Trạng thái hiển thị" prop="">
                      <el-select v-model="mData.tableRules.dataSearch.value.hien_thi" placeholder="Trạng thái"
                        :default-first-option="true" clearable filterable>
                        <el-option v-for="item in mData.dataDefault.listHienThi" :key="item.value" :label="item.label"
                          :value="item.value"></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                </b-row>
                <el-form-item class="text-center mb-0">
                  <el-button type="info" native-type="submit" v-ladda plain
                    @click="fn_tableSearch()">{{ aLang.c_search }}</el-button>
                </el-form-item>
              </el-form>
            </b-card>
          </b-collapse>
        </div>
        <b-row>
          <b-col :class="'col-md-8'">
            <div class="text-left mb-0">
              <b-row>
                <b-col md="4">
                  <el-select v-model="mData.tableRules.dataSearch.value.ngon_ngu" :placeholder="'Ngôn ngữ'"
                    @change="fn_tableSearch()" :default-first-option="true" clearable filterable>
                    <el-option v-for="item in mData.dataDefault.listNgonNgu" :key="item.id" :label="item.name"
                      :value="item.id"></el-option>
                  </el-select>
                </b-col>
              </b-row>
            </div>
          </b-col>
          <b-col :class="'col-md-4'">
            <div class="text-right mb-2">
              <el-button @click="fn_tableShowFormSearch()" type="info" plain>{{ aLang.c_showHideSearch }}</el-button>
              <el-button @click="fn_handle('create')" type="info" plain>{{ aLang.c_create }}</el-button>
            </div>
          </b-col>
        </b-row>
        <el-table :data="mData.tableRules.data" border @selection-change="fn_tableSelectionChange"
          @sort-change="fn_tableSortChange" max-height="440" style="width: 100%"
          :default-sort="{ prop: mData.tableRules.defaultSort[0], order: mData.tableRules.defaultSort[1] }">
          <el-table-column type="selection" width="40" v-if="mData.tableRules.allowSelect"></el-table-column>
          <el-table-column label="STT" width="50">
            <template slot-scope="scope">
              <div class="text-center">
                {{ mData.tableRules.offset + scope.$index + 1 }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="tieu_de" label="Tiêu đề" :sortable="mData.tableRules.allowSorting" width="446px">
            <template slot-scope="scope">
              <el-link class="cell-child" target="_blank" @click="fn_handle('detail', scope.$index, scope.row)"
                :underline="false">{{ scope.row.tieu_de }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="ten_nguoi_tao" label="Người tạo" :sortable="mData.tableRules.allowSorting"
            width="200px">
          </el-table-column>
          <el-table-column prop="thoi_diem_tao" label="Thời điểm tạo" :sortable="mData.tableRules.allowSorting"
            width="140px">
            <template slot-scope="scope">
              <div class="text-center">
                {{ scope.row.thoi_diem_tao }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="ten_nguoi_cap_nhat" label="Người cập nhật" :sortable="mData.tableRules.allowSorting"
            width="200px">
          </el-table-column>
          <el-table-column prop="lastModificationTime" label="Thời điểm cập nhật"
            :sortable="mData.tableRules.allowSorting" width="160px">
            <template slot-scope="scope">
              <div class="text-center">
                {{ scope.row.lastModificationTime }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="hien_thi" label="Trạng thái hiển thị" :sortable="mData.tableRules.allowSorting"
            width="160px">
            <template slot-scope="scope">
              <div class="text-center">
                {{ scope.row.hien_thi ? 'Hiển thị' : 'Ẩn' }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="ngon_ngu" label="Ngôn ngữ" :sortable="mData.tableRules.allowSorting" width="120px">
            <template slot-scope="scope">
              <div class="text-center">
                {{ scope.row.ngon_ngu == "vi" ? 'Tiếng Việt' : scope.row.ngon_ngu == "en" ? 'Tiếng Anh' : '' }}
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="aLang.c_action" align="center" width="150px">
            <template slot-scope="scope">
              <el-button size="mini" @click="fn_handle('detail', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_detail">
                <i class="fa fa-eye"></i>
              </el-button>
              <el-button size="mini" @click="fn_handle('update', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_update">
                <i class="icon-pencil icons"></i>
              </el-button>
              <el-button size="mini" @click="fn_handle('delete', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_delete">
                <i class="icon-trash icons"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
          <div class="col-md-4">
            <div v-if="mData.tableRules.allowSelect">{{ aLang.c_select }}: {{ mData.tableRules.recordSelected.length }}
            </div>
          </div>
          <div class="col-md-8 text-right">
            <el-pagination @size-change="fn_tableSizeChange" @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick" @next-click="fn_tableNextClick" :page-sizes="mData.tableRules.lengthMenu"
              :page-size="mData.tableRules.limit" :current-page="mData.tableRules.page" background
              layout="total, sizes, prev, pager, next, jumper" :total="mData.tableRules.total"
              :pager-count="5"></el-pagination>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from '@/service/DataService';
import TinTucApi from '../../../moduleApi/TinTucApi';
import ProfileApi from '@/moduleApi/ProfileApi';
import MethodService from '../../../service/MethodService';
import TinTucModel from './TinTucModel';
export default {
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        moduleName: "TinTuc", //requied
        tableRules: MethodService.copyObject(TinTucModel.tableRules),
        dataDefault: {
          listNguoiTao: [],
          listNguoiTaoSearch: [],
          listNguoiCapNhat: [],
          listNgonNgu: DataService.Languages,
          listHienThi: DataService.visibleListSearch,
        },
        currentUser: JSON.parse(localStorage.getItem('currentUser')),
        ifHavePermission: false,
        ifHaveCreate: false
      }
    }
  },
  created() {
    if (
      this.mData.currentUser.roles.includes('Officer') ||
      this.mData.currentUser.roles.includes('Admin')
    ) {
      this.mData.ifHaveCreate = false;
    } else if (
      this.mData.currentUser.roles.includes('TourAgent') ||
      this.mData.currentUser.roles.includes('SafePlace') ||
      this.mData.currentUser.roles.includes('Destination') ||
      this.mData.currentUser.roles.includes('Ticket')
    ) {
      this.mData.ifHaveCreate = true;
    }
    this.fn_hashUrl();
    this.getTinTucList();
  },
  methods: {
    async getTinTucList() {
      let dataFilter = {
        filters: this.mData.tableRules.filters + (this.mData.tableRules.filters ? "&" : "") + "category=News&trang_thai=0|trang_thai=2"
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }

      if (this.mData.tableRules.showUrl) {
        this.$router.replace({
          name: "Admin-" + this.mData.moduleName + "-list",
          query: {
            limit: this.mData.tableRules.limit,
            page: this.mData.tableRules.page,
            sort: this.mData.tableRules.sort,
            filters: this.mData.tableRules.filters,
            showFormSearch: this.mData.tableRules.showFormSearch
          }
        }).catch(() => { });
      }

      const resTinTuc = await TinTucApi.list(dataFilter);
      let resData = await this.fn_changeData(resTinTuc.result);
      let nguoiTaoIds = [];
      let nguoiCapNhatIds = [];
      nguoiTaoIds = MethodService.findListItemDifferent(
        resData,
        "nguoi_tao"
      );
      nguoiCapNhatIds = MethodService.findListItemDifferent(
        resData,
        "lastModifierUserId"
      );
      const reqNguoiTaoApi = await ProfileApi.list({
        limit: nguoiTaoIds.length,
        filters: "id:in:" + nguoiTaoIds.join(",")
      })
      const reqNguoiCapNhatApi = await ProfileApi.list({
        limit: nguoiCapNhatIds.length,
        filters: "id:in:" + nguoiCapNhatIds.join(",")
      })
      let resNguoiTaoApi = await reqNguoiTaoApi;
      let resNguoiCapNhatApi = await reqNguoiCapNhatApi;

      this.mData.dataDefault.listNguoiTao = resNguoiTaoApi.result;
      this.mData.dataDefault.listNguoiCapNhat = resNguoiCapNhatApi.result;

      resData.forEach(async (item) => {
        let nguoiTao = this.mData.dataDefault.listNguoiTao.find(
          element => {
            return element.id == item.nguoi_tao;
          }
        );
        if (nguoiTao) {
          item.ten_nguoi_tao = nguoiTao.ho_ten.ho_ten;
        }
        let nguoiCapNhat = this.mData.dataDefault.listNguoiCapNhat.find(
          element => {
            return element.id == item.lastModifierUserId;
          }
        );
        if (nguoiCapNhat) {
          item.ten_nguoi_cap_nhat = nguoiCapNhat.ho_ten.ho_ten;
        }
      });

      this.mData.tableRules.data = resData;
      this.mData.tableRules.total = resTinTuc.meta.total;
      this.mData.tableRules.page = resTinTuc.meta.offset / resTinTuc.meta.limit + 1;
      if (
        this.mData.tableRules.offset == resTinTuc.meta.total &&
        this.mData.tableRules.offset != 0
      ) {
        this.mData.tableRules.offset = 0;
        this.mData.tableRules.page = 1;
        this.getTinTucList();
      }
      this.getNguoiTao();
    },
    async getNguoiTao() {
      const resTinTuc = await TinTucApi.getNguoiTao();
      let nguoiTaoIds = [];
      nguoiTaoIds = MethodService.findListItemDifferent(
        resTinTuc.result,
        "Nguoi_tao"
      );
      const reqNguoiTaoApi = await ProfileApi.list({
        limit: nguoiTaoIds.length,
        filters: "id:in:" + nguoiTaoIds.join(",")
      })
      this.mData.dataDefault.listNguoiTaoSearch = reqNguoiTaoApi.result;
    },
    //xử lý dữ liệu đầu ra
    async fn_changeData(resData) {
      resData.forEach(row => {
        row.thoi_diem_tao = MethodService.formatDate(row.thoi_diem_tao, "datetime");
      })
      resData.forEach(row => {
        row.lastModificationTime = MethodService.formatDate(row.lastModificationTime, "datetime");
      })
      return resData;
    },

    //event table
    fn_tableSelectionChange(val) {
      let _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function (element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.getTinTucList();
    },
    // search
    fn_tableSearch() {
      this.$refs["myForm"].validate(async valid => {
        if (valid && !this.mData.dataDefault.validErrorTime) {
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";
          this.getTinTucList();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.getTinTucList();
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch = !this.mData.tableRules
        .showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query
      });
    },

    fn_handle(type, scope, row) {
      if (type == "create") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-create"
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: row.id }
        });
      }
      if (type == "detail") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: row.id }
        });
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        }).then(() => {
          this.fn_delete(row.id);
        }).catch(() => { });
      }
    },

    async fn_delete(id) {
      await TinTucApi.delete(id);
      this.getTinTucList();
    },
    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
    },
  }
}
</script>

<style scope>
.text-css {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.text-css p {
  margin: 0;
}
</style>
